import React from 'react';

export default function Copyright() {
	let d = new Date();
	let n = d.getFullYear();
	return <div className="footer-copy"> {`Copyright © ${n} Verantos`}</div>;
}
